import { useContext, useState, useEffect, FC } from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as Checkmark } from '../assets/icons/checkmark.svg'
import { ClipLoader } from 'react-spinners'
import './LRSPath.scss'
import { ModuleContext } from '../contexts/ModuleContext'
import { SectionStatus } from '../ModuleTypes'
import * as LearningLab from './learninglab/LearningLab'
import { LRSState } from './learninglab/LearningLab'
import { useLearningLab, LearningLabActionType } from '../contexts/LearningLabContext'
import { HubConnectionState } from '@microsoft/signalr'

interface Props {
  label: string
  path: string
  sectionID: number
  lessonID?: number
  clickHandler?: Function
}

const LRSPath: FC<Props> = ({ label, path, sectionID, lessonID, clickHandler }: Props) => {
  const context = useContext(ModuleContext)
  const { state, dispatch } = useLearningLab()
  const { solverAvailable, userProfile } = context
  const [currentState, setCurrentState] = useState(LRSState.Loading)

  const handleLinkClick = async (e: any) => {
    if (clickHandler !== undefined && clickHandler !== null) {
      e.preventDefault()
    }
    sectionID > 0 && state.currentSectionId !== sectionID && dispatch({ type: LearningLabActionType.SET_CURRENT_SECTION_ID, payload: sectionID })
    state.currentLessonId !== 1 && dispatch({ type: LearningLabActionType.SET_CURRENT_LESSON_ID, payload: 1 })
    const LRSID = LearningLab.lrsID(sectionID, lessonID)
    if (LearningLab.isSectionStatus(userProfile, LRSID, SectionStatus.NotStarted)) {
      await LearningLab.updateLRSStatus(context, LRSID, SectionStatus.Started)
    }

    if (clickHandler !== undefined && clickHandler !== null) {
      clickHandler(e, Number(lessonID))
    }
  }

  useEffect(() => {
    const state = LearningLab.getLRSState(userProfile, sectionID, lessonID)
    setCurrentState(state)
  }, [lessonID, sectionID, solverAvailable, userProfile])

  return (
    <div className={'lrs-path'}>
      <div className={'path-status'}>
        {
          ((currentState === LRSState.Loading || (context.connection.state !== HubConnectionState.Connected)) && <ClipLoader size={25} color={'white'} />)
          ||
          (currentState !== LRSState.Completed && <></>)
          ||
          (currentState === LRSState.Completed && <Checkmark />)
        }
      </div>
      <Link to={path} className={'navLink' + ((currentState === LRSState.Loading || currentState === LRSState.Disabled || (context.connection.state !== HubConnectionState.Connected)) ? ' disabled' : '')} onClick={async (e: any) => { await handleLinkClick(e) }}>{label}</Link>
    </div>
  )
}

export default LRSPath